import { separateMoneyNumbers, toFarsiNumber } from "@utils/digits";
import classNames from "classnames";
import { FC, SVGProps } from "react";
interface Props {
  icon: React.FC<SVGProps<SVGSVGElement>>;
  count: string;
  title: string;
  className?: string;
}

const DetailHeaderItem: FC<Props> = ({ icon, count, title, className }) => {
  const Icon = icon;
  return (
    <div
      className={classNames(
        "flex xl:w-[203px] w-full items-center justify-between rounded-8 bg-fds-brand-light px-2.5 py-2.5  md:px-4 md:py-3.5",
        className
      )}
    >
      <div className="flex flex-col items-center md:justify-start  md:items-start justify-center w-full">
        <p className="md:headline-xsm lg:headline-xsm headline-xxsm text-center">
          {separateMoneyNumbers(toFarsiNumber(count))}
        </p>
        <p className=" title-sm text-center  text-fds-secondary ">{title}</p>
      </div>
      <Icon className="text-fds-icon-on-brand-light opacity-30 hidden md:block  lg:w-10 lg:h-10 w-8 h-8" />
    </div>
  );
};

export default DetailHeaderItem;
